<div *ngIf="uiService.isAuthModalVisible$ | async" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
  <div class="bg-gray-900 border border-violet-500/30 p-8 rounded-2xl max-w-md w-full shadow-2xl relative">
    <button (click)="uiService.closeAuthModal()" class="absolute top-4 right-4 text-gray-400 hover:text-white">✕</button>
    
    <h2 class="text-2xl font-bold text-violet-300 mb-4">Finaliza tu Misión de Forma Segura</h2>
    <p class="text-gray-400 mb-6">
      Para proteger tu compra y activar el rastreo de tu envío, necesitamos validar tu perfil. Es rápido, seguro y necesario para garantizar la entrega.
    </p>

    <ul class="text-sm text-gray-300 space-y-2 mb-8">
      <li>✅ <strong>Seguridad total:</strong> Protegemos tus datos de envío.</li>
      <li>✅ <strong>Rastreo en tiempo real:</strong> Sabrás dónde está tu pedido.</li>
      <li>✅ <strong>Tu primer regalo:</strong> Acumulas puntos desde tu primera compra.</li>
    </ul>

    <div class="space-y-3">
      <a [routerLink]="['/user/login']" (click)="uiService.closeAuthModal()" class="block w-full text-center py-3 rounded-lg bg-violet-600 hover:bg-violet-700 text-white font-bold transition">
        Iniciar Sesión / Registrarme
      </a>
      <button (click)="uiService.closeAuthModal()" class="block w-full text-center py-3 rounded-lg bg-gray-800 hover:bg-gray-700 text-gray-300 font-medium transition">
        Tal vez luego...
      </button>
    </div>
  </div>
</div>
